import { TextBuilder } from '@/utils/text-builder';

export const GA_EVENT_NAME = 'GAevent';

export const getGtmEventData = ({
  event = GA_EVENT_NAME,
  eventAction,
  eventCategory,
  eventLabel,
  params = {},
} = {}) => {
  const gtmParams = event === GA_EVENT_NAME
    ? { eventAction, eventCategory, eventLabel }
    : {};

  return {
    event,
    ...gtmParams,
    ...params,
  };
};

const debugGtmEvent = (data = {}) => {
  const { event, eventAction, eventCategory, eventLabel, ...params } = data;

  if (window.dataLayerDebug) {
    window.dataLayerDebug.push(data);
  } else {
    window.dataLayerDebug = [data];
  }

  const textBuilder = new TextBuilder('%c')
    .addLine(`${event}:`)
    .addLine(`eventAction: ${eventAction}`, eventAction !== undefined)
    .addLine(`eventCategory: ${eventCategory}`, eventCategory !== undefined)
    .addLine(`eventLabel: ${eventLabel}`, eventLabel !== undefined)
    .addLine(`params: ${JSON.stringify(params)}`);

  console.log(textBuilder.toString(), 'background: #FFD73B; color: #000');

  return Promise.resolve();
};

export const gtmEvent = (data) => {
  const gtmEventData = getGtmEventData(data);

  if (process.env.NODE_SERVER === 'dev') return debugGtmEvent(gtmEventData);

  return new Promise((resolve => {
    window?.dataLayer?.push({
      ...gtmEventData,
      eventCallback: (id, result) => {
        if (!id || !result) return resolve(); // если блокируется аналитика, то резолвим сразу
        if (result?.tags?.length) return resolve(); // резолвим, если пришел ответ
      },
    });

    // резолвим через 2 сек, если событие долго идет или блокируется аналитика в браузере,
    setTimeout(resolve, 2000);
  }));
};
